import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ParticipanteService } from 'src/app/Services/participante.service';
import { MunicipioService } from 'src/app/Services/municipio.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Participante } from 'src/app/Models/participante.model';
import { Municipio } from 'src/app/Models/municipio.model';
import { Enumerador } from 'src/app/Models/enumerador.model';
import { ToastrService } from 'ngx-toastr';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { Observable } from 'rxjs';
import { EnumeradorService } from 'src/app/Services/enumerador.service';
import { UserToken } from 'src/app/Models/token.model';

@Component({
  selector: 'cadastro',
  templateUrl: './cadastro.component.html',
  styleUrls: ['./cadastro.component.css']
})
export class CadastroComponent implements OnInit {

  formPreCadastro: FormGroup;
  emailPattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  loading = false;
  @BlockUI() blockUI: NgBlockUI;
  model: Participante;
  sexo: Observable<Enumerador[]>;
  racaCor: Observable<Enumerador[]>;
  escolaridade: Observable<Enumerador[]>;
  oficinappa: Observable<Enumerador[]>;
  areatematica: Observable<Enumerador[]>;
  municipios: Municipio[];
  usuarioLogado: UserToken = null;
  data: string;
  dataValida = true;
  @Input() id: string;
  @Input() disabled;
  @Input() placeholder: string;

  constructor(private rota: Router, private fb: FormBuilder, private participanteService: ParticipanteService,
    private router: Router, private toast: ToastrService, private enumeradorService: EnumeradorService,
    private municipioService: MunicipioService) { }

  ngOnInit() {
    this.inicializarForm();
    this.carregarEnumeradores();

    this.usuarioLogado = JSON.parse(sessionStorage.getItem('usuariologado'));
    this.participanteService.get(this.usuarioLogado.usuario_id)
    .pipe()
    .subscribe((response: any) =>{
      if (response && response.data){
        this.model = response.data[0];
        this.formPreCadastro.patchValue(this.model);
      }
    }, (erroResponse: HttpErrorResponse) => {
      console.log(erroResponse);
    },
    () =>{

    });
  }

  inicializarForm() {
    this.formPreCadastro = this.fb.group({
      nome: this.fb.control('', Validators.required),
      cpf: this.fb.control('', Validators.required),
      email: this.fb.control('', [Validators.required, Validators.pattern(this.emailPattern)]),
      genero: this.fb.control('null'),
      datanascimento: this.fb.control('null'),
      idade: this.fb.control('null'),
      racacor: this.fb.control('null'),
      municipioid: this.fb.control('null', Validators.required),
      escolaridade: this.fb.control('null'),
      pretendeparticiparoficinappa: this.fb.control('null'),
      areatematicadebater: this.fb.control('null'),
      desejareceberatualizacao: this.fb.control('null'),
      tipoparticipante: this.fb.control('null'),
      senha: this.fb.control('', Validators.required)
    });
  }

  salvar(model: Participante) {
    if(this.formPreCadastro.invalid){
      this.toast.error('Preencha todos os campos do formulário corretamente.', 'Atenção', { enableHtml: true });
    }
    else{
      this.blockUI.start('Aguarde...');
      model.participanteid = this.usuarioLogado.usuario_id;
      this.participanteService.put(model)
        .subscribe(() => {
          
        }, (erroResponse: HttpErrorResponse) => {
          this.formPreCadastro.patchValue(model, { onlySelf: true });
          this.toast.error(erroResponse.error.message, 'Atenção', { enableHtml: true });
          this.blockUI.stop();
        },
      ()=> {
        setTimeout(() => {
          this.blockUI.stop();
          this.rota.navigate(['participante']);
          this.toast.success('Cadastro atualizado com sucesso.', 'Atenção', { enableHtml: true });
        }, 2000);
      });
    }
  }

  voltar() {
    this.rota.navigate(['participante']);
  }

  carregarEnumeradores() {
    this.sexo = this.enumeradorService.get('ESexo');
    this.racaCor = this.enumeradorService.get('ERacaCor');
    this.escolaridade = this.enumeradorService.get('ENivelEscolaridade');
    this.oficinappa = this.enumeradorService.get('EOficinaPresencialPPA');
    this.areatematica = this.enumeradorService.get('EAreaTematica');
    this.municipioService.get()
    .subscribe((response: any) =>{
      if (response && response.data){
        this.municipios = response.data;
      }
    });
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
  }

  onBlur() {
    if (this.data != null && !this.validarData()) {
      this.data = '';
      this.dataValida = false;
    } else {
      this.dataValida = true;

      var dataFinal = new Date();
      var dataInicial = new Date(this.data);
      var timeDiff = Math.abs(dataInicial.getTime() -  dataFinal.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)); 
      this.formPreCadastro.patchValue({'idade' : Math.round(diffDays / 365)});
    }

    this.propagateChange(this.data);
  }

  emitirData() {
    if (this.data.search('_') === -1) {
      if (!this.validarData()) {
        this.data = '';
      }
    }
    this.propagateChange(this.data);
  }

  validarData(): boolean {
    const [day, month, year] = this.data.split('/');

    const dia = Number(day);
    const mes = Number(month);
    const ano = Number(year);

    if (Number.isNaN(dia) || Number.isNaN(mes) || Number.isNaN(ano)) {
      return false;
    }

    if ((mes === 1) || (mes === 3) || (mes === 5) || (mes === 7) || (mes === 8) || (mes === 10) || (mes === 12)) {
      if ((dia >= 1) && (dia <= 31)) {
        return true;
      }
    }

    if ((mes === 4) || (mes === 6) || (mes === 9) || (mes === 11)) {
      if ((dia >= 1) && (dia <= 30)) {
        return true;
      }
    }

    if ((mes === 2)) {
      if ((ano % 4 === 0) && ((ano % 100 !== 0) || (ano % 400 === 0))) {
        if ((dia >= 1) && (dia <= 29)) {
          return true;
        }
      } else {
        if ((dia >= 1) && (dia <= 28)) {
          return true;
        }
      }
    }

    return false;
  }

  writeValue(value: any): void {
    if (value !== undefined) {
      this.data = value;
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  propagateChange = (_: any) => { };

  registerOnTouched(fn: any): void { }

}
